import React from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";

const Main = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, children, ...props }, ref) => {
  return (
    <div
      className={clsx(styles.main, className)}
      {...props}
      ref={ref}
    >
      <div className={clsx(styles.container, "js-container")}>{children}</div>
    </div>
  );
});

export default Main;
